<script>

    import { toast } from 'bulma-toast'

    import StatisticsService from '../$services/statistics.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import StatsCard from '../$components/stats.card.svelte'
    import Spinner from '../$components/spinner.svelte'

    export let dateStart = null
    export let dateEnd = null

    let loading = false
    let clients = []

    $: if (dateStart && dateEnd)
        getClientsTop()

    async function getClientsTop() {
        loading = true
        clients = []

        const resp = await StatisticsService.getShipmentsClientsTop({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
        })

        loading = false

        if (!resp.success)
            return toast({ message: resp.error.message, type: 'is-danger' })

        clients = resp.data?.clients ?? []
    }

</script>

<style>
    .clients-list {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
    }

    .clients-list__item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.85rem 0;
        border-bottom: 1px solid #eee;
    }

    .clients-list__item:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    .clients-list__item:first-child {
        padding-top: 0;
    }

    .clients-list__rank {
        flex-shrink: 0;
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 50%;
        background: #f4f4f4;
        color: #666;
        font-size: 12px;
        font-weight: 700;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .clients-list__info {
        flex: 1;
        min-width: 0;
    }

    .clients-list__title {
        font-size: 14px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0 0 2px;
    }

    .clients-list__meta {
        font-size: 12px;
        color: #a0a0a0;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .clients-list__total {
        flex-shrink: 0;
        font-size: 15px;
        font-weight: 700;
        color: var(--color-primary, #098E37);
    }
</style>

<StatsCard icon="fa-users" meta="Envíos" title="Top clientes" {dateStart} {dateEnd}>
    <div>
        <Spinner {loading} />
        {#if !loading && clients.length}
            <ul class="clients-list">
                {#each clients as client, index}
                    <li class="clients-list__item">
                        <span class="clients-list__rank">{ index + 1 }</span>
                        <div class="clients-list__info">
                            <p class="clients-list__title">{ client.name }</p>
                            <p class="clients-list__meta">{ client.email }</p>
                        </div>
                        <span class="clients-list__total">{ NumeralMethods.number(client.total) } envíos</span>
                    </li>
                {/each}
            </ul>
        {:else if !loading}
            <p class="empty">Sin datos en el periodo seleccionado</p>
        {/if}
    </div>
</StatsCard>
